export default function RedCrossBadge({ size = 56, withText = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="red-cross-badge">
      <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="American Red Cross" className="flex-shrink-0 drop-shadow-lg">
        <rect x="2" y="2" width="60" height="60" rx="6" fill="#FFFFFF" />
        <rect x="2" y="2" width="60" height="60" rx="6" fill="none" stroke="#E5E5E5" strokeWidth="1.5" />
        <path d="M24 10h16v14h14v16H40v14H24V40H10V24h14z" fill="#ED1B2E" />
      </svg>
      {withText && (
        <div className="leading-tight">
          <div className="font-heading text-base tracking-tight text-white">American Red Cross</div>
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-400">Authorized Training Provider</div>
        </div>
      )}
    </div>
  );
}
